<template>
  <div class="home">
    <h1 class="mt-16 text-h4 font-weight-bold text-center">
      {{ $city.name }}政府健檢預約平台
    </h1>

    <v-row class="mt-8 mx-0" justify="center">
      <v-col
        class="col-auto"
        v-for="(value, key) of person.篩檢項目"
        :key="key"
        v-if="value"
      >
        <div class="mb-4">
          <v-img
            contain
            max-height="50"
            :src="items[key].logo"
            alt=""
          ></v-img>
        </div>
        <h2
          class="font-weight-bold text-h6 text-center red--text text--darken-2"
        >
          {{ items[key].title }}
        </h2>
      </v-col>
    </v-row>
    <h2 class="my-8 text-h5 font-weight-bold text-center">預約場次</h2>
    <div>
      <v-card class="mx-auto mt-4" max-width="400px">
        <v-card-text>
          <reserveSection v-model="section"></reserveSection>
          <v-row justify="center">
            <v-col class="col-auto">
              <v-btn
                @click="$router.go(-1)"
                class="mt-4 px-10 mx-2"
                x-large
                color="primary"
              >
                上一頁
              </v-btn>
              <v-btn
                @click="saveDebounce"
                class="mt-4 px-8 mx-2"
                x-large
                color="primary"
                >確認預約</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import reserveSection from "@/components/People/reserveSection.vue";
import { 健檢項目 } from "@/libs/const.js";
export default {
  name: "Section",
  components: { reserveSection },
  data: () => ({
    valid: false,
    person: null,
    sections: [],
    section: null,
    items: 健檢項目,
  }),
  computed: {
    // 行政區() {
    //   let 行政區 = this.sections.map((section) => section.行政區);
    //   return [...new Set(行政區)];
    // },
    // 日期地點() {
    //   let 日期地點 = this.sections
    //     .filter((section) => section.行政區 == this.selected.行政區)
    //     .map((section) => ({
    //       text: `${section.日期} ${section.地點}`,
    //       value: {
    //         日期: section.日期,
    //         地點: section.地點,
    //       },
    //     }));
    //   return [...new Set(日期地點)];
    // },
    // 時段() {
    //   let 時段 = this.sections
    //     .filter(
    //       (section) =>
    //         section.行政區 == this.selected.行政區 &&
    //         section.日期 == this.selected.日期地點.日期 &&
    //         section.地點 == this.selected.日期地點.地點
    //     )
    //     .map((section) => ({
    //       text: `${section.開始時間}-${section.結束時間} (尚有${
    //         section.人數上限 - section.已預約
    //       }個名額)`,
    //       value: section._id,
    //     }));
    //   return [...new Set(時段)];
    // },
  },
  async created() {
    this.person = { ...this.$store.state.person };
    this.sections = (await this.axios.get("/sections")).data;
    this.saveDebounce = _.debounce(this.save, 500);
  },
  methods: {
    saveDebounce() {},
    async save() {
      if (this.section) {
        try {
          let 時段 = (
            await this.axios.post("/reserve", {
              person: this.person,
              section: this.section,
            })
          ).data;
          let person = { ...this.person, ...時段 };
          this.$store.commit("setState", { person });
          this.$router.push("/confirm");
          this.$toast.success("預約成功！");
        } catch (e) {
          this.$toast.error("無法預約此時段，請選擇其他時段！");
        }
      } else {
        this.$toast.error("請選擇預約時段！");
      }
    },
  },
  watch: {
    "selected.行政區"() {
      this.selected.日期地點 = {
        日期: null,
        地點: null,
      };
      this.selected.時段 = null;
    },
    "selected.日期地點"() {
      this.selected.時段 = null;
    },
  },
};
</script>
<style lang="scss" scoped></style>
